import MobileViewGenerator from '../../../MobileViewGenerator/MobileViewGenerator';
import ListLocationItem from '../../../MobileViewGenerator/subdirectives/list/Location/Location';
import EditLocationItem from '../../../MobileViewGenerator/subdirectives/edit/Location/Location';

export default MobileViewGenerator(ListLocationItem, EditLocationItem);


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/policycommon/common/directives/schedules/scheduleTypes/editable/MobileLocation/MobileLocation.js
// module id = 288
// module chunks = 0